module.exports = __webpack_public_path__ + "img/fashion_91.6e90eab3.jpg";